import { type ForwardedRef, forwardRef } from 'react';
import type { OptionTypeBase } from 'react-select';
import type { Props as ReactSelectAsyncCreatableProps } from 'react-select/async-creatable';

import { BaseSelect } from './BaseSelect';
import { SelectType } from './SelectType';
import type { CustomizeMenuPortaling } from './types';

export type AsyncCreatableSelectProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = CustomizeMenuPortaling<ReactSelectAsyncCreatableProps<OptionType, IsMulti>>;

export const AsyncCreatableSelect = forwardRef(
  <OptionType extends OptionTypeBase, IsMulti extends boolean>(
    props: AsyncCreatableSelectProps<OptionType, IsMulti>,
    forwardedRef: ForwardedRef<unknown>,
  ) => (
    <BaseSelect
      customRef={forwardedRef}
      selectType={SelectType.ASYNC_CREATABLE}
      selectProps={props}
    />
  ),
);
AsyncCreatableSelect.displayName = 'AsyncCreatableSelect';
